module.exports = __webpack_public_path__ + "static/media/kaaba.f34c2b57.svg";